import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function Hero() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section id="inicio" className="relative min-h-[85vh] md:min-h-[90vh] flex items-center justify-center pt-32 pb-10 md:pt-40 md:pb-14 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #B8D8F8 0%, #C8E2FA 30%, #DCEEFF 55%, #EDF5FC 80%, #FFFFFF 100%)'
  }} data-id="element-88">
      {/* Soft radial white glow behind content */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] md:w-[70%] h-[70%] rounded-full pointer-events-none z-[1]" style={{
      background: 'radial-gradient(ellipse at center, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.3) 40%, rgba(255,255,255,0) 70%)',
      filter: 'blur(40px)'
    }} data-id="element-89"></div>

      {/* Secondary subtle glow — upper area */}
      <div className="absolute top-[15%] left-1/2 -translate-x-1/2 w-[60%] h-[40%] rounded-full pointer-events-none z-[1]" style={{
      background: 'radial-gradient(ellipse at center, rgba(255,255,255,0.45) 0%, rgba(255,255,255,0) 65%)',
      filter: 'blur(60px)'
    }} data-id="element-90"></div>

      {/* Decorative Background Letters — pale, ethereal */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full flex justify-center pointer-events-none select-none overflow-hidden z-[2]" data-id="element-91">
        <span className="font-heading text-[12rem] md:text-[18rem] lg:text-[22rem] uppercase tracking-wider leading-none" style={{
        color: 'rgba(255,255,255,0.35)'
      }} data-id="element-92">
          GOBERNANZA
        </span>
      </div>

      {/* Second decorative layer — very faint blue tint */}
      <div className="absolute top-[40%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-full flex justify-center pointer-events-none select-none overflow-hidden z-[2]" data-id="element-93">
        <span className="font-heading text-[8rem] md:text-[12rem] lg:text-[16rem] uppercase tracking-[0.15em] leading-none" style={{
        color: 'rgba(200,220,240,0.2)'
      }} data-id="element-94">
          EFICCI
        </span>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-8 w-full relative z-10 flex flex-col items-center text-center" data-id="element-95">
        <div ref={ref} className={`max-w-4xl mx-auto flex flex-col items-center scroll-animate ${isVisible ? 'is-visible' : ''}`} data-id="element-96">
          <span className="font-body text-xs uppercase tracking-[0.25em] text-[#5F7186] mb-6 block" data-id="element-97">
            Consultoría de incidencia y políticas públicas
          </span>

          <div className="w-16 h-px bg-[#B0BEC9] mx-auto mb-8" data-id="element-98"></div>

          <h1 className="font-heading font-light text-5xl md:text-6xl lg:text-7xl xl:text-[5.5rem] text-[#0A3F6B] leading-[1.1] mb-6" data-id="element-99">
            La Nueva Arquitectura <br data-id="element-100" />
            de la Gobernanza
          </h1>

          <p className="font-body text-lg md:text-xl text-[#5F7186] max-w-2xl mx-auto leading-relaxed mb-8" data-id="element-101">
            Redefinimos la intersección entre el sector público y el privado.
            Claridad estratégica, hojas de ruta ejecutivas y gobernanza que
            funciona.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-5 w-full sm:w-auto" data-id="element-102">
            <button onClick={() => scrollToSection('servicios')} className="w-full sm:w-auto border border-[#9BB0C4] text-[#0A3F6B] font-body text-xs uppercase tracking-[0.2em] px-8 py-4 rounded-sm hover:border-[#0A3F6B] hover:bg-white/40 transition-all duration-300 backdrop-blur-sm" data-id="element-103">
              Ver servicios
            </button>
          </div>
        </div>
      </div>

      {/* Subtle Bottom Rule */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-7xl mx-auto h-px bg-gradient-to-r from-transparent via-[#B0BEC9]/40 to-transparent z-10" data-id="element-104"></div>
    </section>;
}